export const ADSTERRA_AD_INTERVAL = 5;

export const getThirdPartySponsoredSlotCount = (
  availableSlots: number,
  ownSponsoredCount: number,
) => Math.max(0, availableSlots - ownSponsoredCount);

const DEFAULT_SPONSORED_INTERNAL_ROTATION_MS = 60_000;
const MIN_SPONSORED_INTERNAL_ROTATION_MS = 30_000;

export const getSponsoredInternalRotationInterval = (value?: string) => {
  const interval = Number(value);
  return Number.isFinite(interval) &&
    interval >= MIN_SPONSORED_INTERNAL_ROTATION_MS
    ? interval
    : DEFAULT_SPONSORED_INTERNAL_ROTATION_MS;
};

export const SPONSORED_INTERNAL_ROTATION_MS =
  getSponsoredInternalRotationInterval(
    process.env.REACT_APP_SPONSORED_INTERNAL_ROTATION_MS,
  );

export interface AdsterraBannerConfiguration {
  key: string;
  scriptUrl: string;
  width: number;
  height: number;
}

const parseDimension = (value: string | undefined, fallback: number) => {
  const dimension = Number(value);
  return Number.isInteger(dimension) && dimension > 0 ? dimension : fallback;
};

const normalizeScriptUrl = (value: string | undefined) => {
  const scriptUrl = value?.trim() || '';

  try {
    const url = new URL(scriptUrl);
    return url.protocol === 'https:' ? url.toString() : '';
  } catch {
    return '';
  }
};

export const ADSTERRA_FEED_BANNER: AdsterraBannerConfiguration = {
  key: process.env.REACT_APP_ADSTERRA_FEED_ZONE_KEY?.trim() || '',
  scriptUrl: normalizeScriptUrl(
    process.env.REACT_APP_ADSTERRA_FEED_SCRIPT_URL,
  ),
  width: parseDimension(process.env.REACT_APP_ADSTERRA_FEED_WIDTH, 300),
  height: parseDimension(process.env.REACT_APP_ADSTERRA_FEED_HEIGHT, 250),
};

const warnedMissingConfiguration = new Set<string>();

export const isAdsterraBannerConfigurationValid = (
  configuration: AdsterraBannerConfiguration,
) =>
  Boolean(
    configuration.key &&
      configuration.scriptUrl &&
      configuration.width > 0 &&
      configuration.height > 0,
  );

export const isAdsterraFeedConfigured = () => {
  const configured = isAdsterraBannerConfigurationValid(ADSTERRA_FEED_BANNER);

  if (
    !configured &&
    process.env.NODE_ENV !== 'test' &&
    !warnedMissingConfiguration.has('feed')
  ) {
    warnedMissingConfiguration.add('feed');
    console.warn(
      '[Adsterra] Configuração inválida para o feed. Configure a zone key e a URL HTTPS do script da unidade Banner.',
    );
  }

  return configured;
};

export type FeedAdProvider = 'google' | 'adsterra';

export const getFeedAdProvider = (): FeedAdProvider =>
  process.env.REACT_APP_FEED_AD_PROVIDER?.trim().toLowerCase() === 'adsterra'
    ? 'adsterra'
    : 'google';
